import { DecimalPipe, UpperCasePipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { AuthResponse, PaymentMethod } from "@apiserver-rest/ponder-auth-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { take } from "rxjs";

@Component({
    selector: "user-payment-method",
    imports: [UpperCasePipe, DecimalPipe, SvgIconComponent, BusySpinComponent],
    templateUrl: "./user-payment-method.component.html"
})
export class UserPaymentMethod {
    @Input({ required: true }) public paymentMethod!: PaymentMethod;

    public deleteIcon: SvgIcon = SvgIcon.Delete;
    public isDeleting: boolean = false;
    public deletionError: boolean = false;

    public constructor(private ponderAuthClient: PonderAuthClient, private events: EventBroker) {

    }

    public ngOnInit(): void {

    }

    public onDeleteClicked(): void {
        if (this.isDeleting) {
            return;
        }

        this.isDeleting = true;
        this.deletionError = false;

        this.ponderAuthClient
            .subscriptionPaymentMethodDelete(this.paymentMethod.id)
            .pipe(take(1))
            .subscribe({
                next: (response: AuthResponse) => {
                    if (response.success) {
                        this.events.account.paymentMethodRemovedEvent.emit(this.paymentMethod.id);
                    } else {
                        this.deletionError = true;
                    }
                },
                error: () => {
                        this.deletionError = true;
                }
            })
            .add(() => this.isDeleting = false);
    }
}